import Navbar from './components/Navbar';
import Hero from './components/Hero';
import AboutSection from './components/AboutSection';
import CategoryGrid from './components/CategoryGrid';
import SEOArticleSection from './components/SEOArticleSection';
import Testimonials from './components/Testimonials';
import CTASection from './components/CTASection';
import Footer from './components/Footer';

const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'Itaobuy Spreadsheet Italia',
  url: 'https://itaobuyspread.click/',
  logo: 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/62f99c0415358bd5388d5ed1df9ac1ff.jpeg',
  description: 'La più completa guida italiana per Itaobuy Spreadsheet. Liste prodotti, categorie organizzate e guide aggiornate per trovare prodotti migliori.',
  sameAs: [
    'https://kaspreadsheet.com',
  ],
};

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'Itaobuy Spreadsheet Italia',
  url: 'https://itaobuyspread.click/',
  description: 'Portale italiano dedicato a Itaobuy Spreadsheet con liste prodotti, categorie organizzate, guide complete e confronti dettagliati.',
  inLanguage: 'it',
};

export default function Home() {
  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationSchema) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }} />

      <main>
        <Navbar />
        <Hero />
        <AboutSection />
        <CategoryGrid />
        <SEOArticleSection />
        <Testimonials />
        <CTASection />
        <Footer />
      </main>
    </>
  );
}